module.exports = __webpack_public_path__ + "img/partly-cloudy-day.556f09e8.svg";